import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import { ProductConfig } from '../../../types';
import { AvailableLanguagesService } from '../../../../../zalamo/language/available-languages.service';
import { translationProvider } from '@ui/nls/translations/translate.directive';

@Component({
    selector: 'lib-product-config-parser',
    templateUrl: './product-config-parser.component.html',
    styleUrls: ['./product-config-parser.component.scss'],
    providers: [translationProvider('productOrderFront')],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProductConfigParserComponent implements OnInit, OnChanges {
  parsed: Array<{ name: string; value: string; type: string }> = [];
  @Input() picked: { [x: string]: string };
  @Input() dump: ProductConfig;
  @Input() skipEmpty = false;

  constructor(
    private cd: ChangeDetectorRef,
    private language: AvailableLanguagesService,
  ) {}

  ngOnInit(): void {
    this.draw();
    this.cd.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.draw();
  }

  draw() {
    if (typeof this.dump === 'string') {
      this.dump = JSON.parse(this.dump);
    }
    if (typeof this.picked === 'string') {
      this.picked = JSON.parse(this.picked);
    }
    if (!this.dump.config) {
      this.dump.config = this.dump.configuration;
    }
    if (typeof this.dump.config === 'string') {
      this.dump.config = JSON.parse(this.dump.config);
    }
    this.parsed = Object.entries(this.picked)
      .filter(([key, value]) => (this.skipEmpty ? !!value : true))
      .map(([key, value]) => {
        switch (key) {
          case 'color':
            return {
              name: 'color',
              type: 'color',
              value: this.dump.colors.find(
                (c) => c.productColorConfigId === value,
              ).name,
            };
          case 'material':
            return {
              name: 'material',
              type: 'material',
              value: this.dump.material.find(
                (c) => c.productMaterialId === value,
              ).name,
            };
          case 'size':
            const size = this.dump.sizes.find(
              ({ productConfigSizeId }) => productConfigSizeId === value,
            );
            return {
              name: 'size',
              type: 'size',
              value: `${size.width}x${size.height}`,
            };

          default:
            const option = this.dump.config.find(
              ({ customId }) => customId === key,
            );
            if (!option) {
              return null;
            }
            if (option.type === 'boolean') {
              return {
                type: 'boolean',
                name: option.label.find(
                  ({ language }) =>
                    language === this.language.getCurrentLanguage(),
                ).text,
                value,
              };
            }
            return {
              type: 'custom',
              name:
                option.label.find(
                  ({ language }) =>
                    language === this.language.getCurrentLanguage(),
                )?.text ?? option.label[0].text,
              value: ['list', 'size', 'decoration'].includes(option.type)
                ? option.options
                    .find(({ configId }) => configId === value)
                    ?.label.find(
                      ({ language }) =>
                        this.language.getCurrentLanguage() === language,
                    )?.text ??
                  option.options.find(({ configId }) => configId === value)
                    ?.label[0].text
                : value,
            };
        }
      })
      .filter((v) => !!v);
  }
}
